import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/test.environment';
import { Observable } from 'rxjs';

export interface Company {
  companyId: number;
  name: string;
  dbName: string;
  companyLogo: string;
}
@Injectable({ providedIn: 'root' })
export class CompanyService {
  constructor(private http: HttpClient) {}

  getCompanyById(id: string): Observable<Company> {
    return this.http.get<Company>(`${environment.apiBaseUrl}/api/companies/${id}`);
  }

  uploadCompanyLogo(companyId: string, formData: FormData): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/api/companies/${companyId}/upload/logo`, formData);
  }

}
